import { FC } from "react";
import { Grid } from "@mui/material";
import { BrowserProvider, Contract, parseUnits, ZeroAddress } from "ethers";

import { PageHeader } from "@dzambalaorg/mui-page-layout";
import { FormWrapper } from "@dzambalaorg/mui-form";
import { useMetamask, Web3ContextType } from "@dzambalaorg/react-hooks-eth";

import ERC20TransferABI from "../../../abis/erc20.transfer.abi.json";
import { Root } from "../../../components/common/styled";
import { validationSchema } from "./validation";
import { ContractInput } from "./contract-input";
import { AmountInput } from "./amount-input";

export interface ITransferDto {
  amount: number;
  contract: {
    address: string;
    decimals: number;
  };
}

export const Payment: FC = () => {
  const metaFn = useMetamask(async (values: ITransferDto, web3Context: Web3ContextType) => {
    const rawProvider = await web3Context.connector!.getProvider();
    const provider = new BrowserProvider(rawProvider as any);
    const signer = await provider.getSigner();

    const contract = new Contract(values.contract.address, ERC20TransferABI, signer);
    return contract.transfer("0xe0b106c00250ca37079aa171a248090ddb3e6725", values.amount) as Promise<void>;
  });

  const handleSubmit = (values: ITransferDto): Promise<any> => {
    return metaFn(values);
  };

  return (
    <Root>
      <Grid>
        <PageHeader message="pages.payment.title" />

        <FormWrapper
          initialValues={{
            amount: parseUnits("2000", 18).toString(),
            contract: {
              address: ZeroAddress,
              decimals: 18,
            },
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          <ContractInput />
          <AmountInput />
        </FormWrapper>
      </Grid>
    </Root>
  );
};
